import React from 'react';
import KeyIcon from '@mui/icons-material/Key';
import {keyframes, styled, Tooltip} from '@mui/material';
import ErrorIcon from "@mui/icons-material/ErrorOutline";

const PulsingNfcIcon = styled(KeyIcon)(({theme}) => ({
    animation: `${keyframes`
        0%, 100% {
            color: ${theme.palette.primary.main};
        }
        50% {
            color: transparent;
        }
    `} 1s ease-in-out infinite`,
}));

export function NfcScanIcon({pulse, error, onClick}: {
    pulse: boolean,
    error?: string,
    onClick?: () => void,
}) {
    return pulse ? (
        <PulsingNfcIcon fontSize="small"/>
    ) : (error ? (
        <Tooltip title={error}>
            <ErrorIcon
                fontSize="small"
                color="error"
                onClick={onClick}
                sx={{cursor: onClick ? 'pointer' : 'default'}}
            />
        </Tooltip>
    ) : (
        <KeyIcon fontSize="small" color="primary"/>
    ));
}
